import React, { useState } from 'react';
import styled from 'styled-components';
import { Styles, TooltipMain as ToolkitTooltipMain, TooltipInnerWrapper } from '@contently/toolkit';

const Container = styled.div`
  width: 36px;
  height: 36px;
  position: relative;
  display: inline-block;
  left: -${props => props.order*6}px;
  vertical-align: top;
  &:hover {
    cursor: pointer;
  }
`;

const AvatarImg = styled.img`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid #FFFFFF;
  box-shadow: inset 0 0 0 3px ${props => props.borderColor};
  padding: 3px;
  background-color: ${props => props.borderColor};
  display: inline-block;
`;

const AvatarNoImg = styled.span`
  width: 38px;
  height: 38px;
  line-height: 28px;
  border-radius: 50%;
  border: 2px solid #FFFFFF;
  box-shadow: inset 0 0 0 3px ${props => props.borderColor};
  padding: 3px;
  background-color: ${props => props.borderColor};
  color: white;
  text-align: center;
  font-weight: 500;
  display: inline-block;
`;

const BadgeWrapper = styled.span`
  width: ${props => props.managingEditor ? '14' : '12'}px;
  line-height: 10px;
  background: ${props => props.managingEditor ? Styles.colors.grey.primary : Styles.colors.blue.primary};
  color: white;
  border-radius: 2px;
  text-align: center;
  font-weight: 500;
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 8px;
  bottom: 0px;
  right: 0px;
`;

const TooltipMain = styled(ToolkitTooltipMain)`
  max-width: unset;
  max-height: 40px;
  width: 400px;
`;

function initials(fullName) {
  return fullName.split(/\s+/).slice(0,2).map(s => s.charAt(0)).join('');
}

function Badge({managingEditor, contentlyEmployee}) {
  if (!contentlyEmployee && !managingEditor) return null;

  const badgeText = managingEditor ? 'ME' : 'C';

  return <BadgeWrapper managingEditor={managingEditor} >{badgeText}</BadgeWrapper>;
}

function Avatar({color, name, url}) {
  const userHasNoIcon = url.match(/default_avatar\.png$/);

  if (userHasNoIcon) return(
    <AvatarNoImg borderColor={color}>
      {initials(name)}
    </AvatarNoImg>
  );

  return <AvatarImg src={url} borderColor={color} />;
}

function tooltipContent({name, managingEditor, contentlyEmployee}) {
  let suffix = '';
  if (managingEditor) suffix += ' (Managing Editor)';
  if (contentlyEmployee) suffix += ' (Contently Employee)';

  return <span>{name + suffix}</span>;
}

export default function EditingAvatar({
  color,
  name,
  avatar_url: avatarUrl,
  managing_editor: managingEditor,
  contently_employee: contentlyEmployee,
  order
}) {
  const [hoverOn, setHoverOn] = useState(false);
  const toggleHoverOn = () => setHoverOn(true);
  const toggleHoverOff = () => setHoverOn(false);

  if (!name) return null;

  return(
      <Container
        order={order}
        onMouseEnter={toggleHoverOn}
        onMouseLeave={toggleHoverOff}
        key={order}
      >
        <Avatar color={color} name={name} url={avatarUrl} />
        <Badge managingEditor={managingEditor} contentlyEmployee={contentlyEmployee} />
        <TooltipMain
          position={'start'}
          hoverOn={hoverOn}
          left={'0px'}
        >
          <TooltipInnerWrapper>
            {tooltipContent({name, managingEditor, contentlyEmployee})}
          </TooltipInnerWrapper>
        </TooltipMain>
      </Container>
  );
}




// WEBPACK FOOTER //
// ./app/javascript/client/components/CurrentlyEditingUsers/EditingAvatar.jsx